import { useState, useCallback } from "react";

/**
 * useToast
 * Shared across AdminConsole, LeadManagement, and Quality.
 * Replaces the copy-pasted toast state + showToast function in all three files.
 *
 * Usage:
 *   const { toast, showToast } = useToast();
 *
 *   showToast("Saved successfully.");
 *   showToast("Something went wrong.", "error");
 *
 * Render in JSX:
 *   <Toast toast={toast} />
 *   — or inline if you haven't extracted Toast yet:
 *   {toast && (
 *     <div className={styles.toast}>
 *       <div className={toast.type === "error" ? styles.toastError : styles.toastSuccess}>
 *         {toast.text}
 *       </div>
 *     </div>
 *   )}
 */
export function useToast(durationMs = 3500) {
  const [toast, setToast] = useState(null); // { text: string, type: "success" | "error" }

  const showToast = useCallback(
    (text, type = "success") => {
      setToast({ text, type });
      setTimeout(() => setToast(null), durationMs);
    },
    [durationMs],
  );

  return { toast, showToast };
}